import React, { useState, useEffect, useCallback } from "react";
import InputFactory from "../../../components/InputFactory";

function DialogCreate({ create, objects, handleSubmit, handleClose }) {
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
  });

  const handleChange = useCallback((value, field) => {
    setFormData((prevData) => ({
      ...prevData,
      [field]: value,
    }));
  }, []);

  const _handleSubmit = useCallback(() => {
    const updatedFormData = {
      ...formData,
      ...objects,
    };

    handleSubmit(updatedFormData);
  }, [formData, handleSubmit]);

  return (
    <div className="p-4 rounded" style={{ maxWidth: "450px", margin: "auto" }}>
      <div
        className="d-flex align-items-center mb-3"
        style={{ color: "#d18237" }}
      >
        <div
          className="bg-light p-3 rounded-circle d-flex justify-content-center align-items-center"
          style={{ width: "50px", height: "50px" }}
        >
          <i className="bi bi-plus-circle fs-4"></i>
        </div>
        <h5 className="fw-bold ms-2">Add to Queue</h5>
      </div>

      <div className="mb-3">
        <label className="form-label fw-bold">First Name</label>
        <InputFactory
          type="String"
          field="firstName"
          onChange={(value, field) => handleChange(value, field)}
          placeholder="Enter first name"
          defaultValue={
            formData.qualificationStandard || objects?.qualificationStandard
          }
        />
      </div>

      <div className="mb-3">
        <label className="form-label fw-bold">Last Name</label>
        <InputFactory
          type="String"
          field="lastName"
          onChange={(value, field) => handleChange(value, field)}
          placeholder="Enter last name"
          defaultValue={formData.jobDescription || objects?.jobDescription}
        />
      </div>

      <div className="d-flex justify-content-center">
        <button
          className="btn text-white me-2 px-4"
          style={{ backgroundColor: "#d18237" }}
          onClick={() => _handleSubmit()}
        >
          Confirm
        </button>
        <button
          className="btn px-4"
          onClick={() => handleClose()}
          style={{ backgroundColor: "#d0d0d0" }}
        >
          Cancel
        </button>
      </div>
    </div>
  );
}

export default DialogCreate;
